// Matches either native shell (iOS or Android). The name is kept for
// backwards-compat with existing call sites whose UI/UX behavior is the same
// across both apps. Use isIOSAppVersionAtMost() when iOS-only version gating
// is needed.
export const isIOSNativeApp = (): boolean => {
  return navigator.userAgent.includes('MoonlightApp-iOS') ||
         navigator.userAgent.includes('MoonlightApp-Android');
};

// Returns the iOS app version string from the user agent (e.g. "MoonlightApp-iOS/1.3.2" → "1.3.2")
// Returns "0" if not an iOS native app or version can't be parsed
export const getIOSAppVersion = (): string => {
  const match = navigator.userAgent.match(/MoonlightApp-iOS\/([0-9.]+)/);
  return match ? match[1] : '0';
};

// Compares two semver strings. Returns:
//  -1 if a < b, 0 if a == b, 1 if a > b
const compareSemver = (a: string, b: string): number => {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const na = pa[i] || 0;
    const nb = pb[i] || 0;
    if (na < nb) return -1;
    if (na > nb) return 1;
  }
  return 0;
};

// Returns true if the iOS app version is less than or equal to the given version.
// Android native app always returns false here so it gets the newer iOS branches
// rather than legacy fallbacks.
export const isIOSAppVersionAtMost = (version: string): boolean => {
  if (!navigator.userAgent.includes('MoonlightApp-iOS')) return false;
  return compareSemver(getIOSAppVersion(), version) <= 0;
};

export const isIPad = (): boolean => {
  return navigator.userAgent.includes('iPad') ||
         (navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1);
};
